import * as React from 'react'

import { ChevronRightIcon } from 'lucide-react'
import { action, makeObservable, observable } from 'mobx'
import { observer } from 'mobx-react'

import FilterLabel from '~/client/src/desktop/components/Filters/SavedFilters/components/FilterLabel'
import CustomDeliveryListFilter from '~/client/src/shared/types/CustomDeliveryListFilter'
import CustomWorkflowsFilter from '~/client/src/shared/types/CustomWorkflowFilter'

import '../../SavedFilters.scss'

// localization: no display text to translate

interface IProps {
  customFilter: CustomDeliveryListFilter | CustomWorkflowsFilter
  getEntitiesCountByCustomFilter: (
    filter: CustomDeliveryListFilter | CustomWorkflowsFilter,
  ) => number
  selectCustomFilterById: (id: string) => void
  editCustomFilter: () => void
}

@observer
export default class SavedFilterLabel extends React.Component<IProps> {
  @observable private activityCountByCustomFilter: number = 0

  public constructor(props: IProps) {
    super(props)

    this.activityCountByCustomFilter = props.getEntitiesCountByCustomFilter(
      props.customFilter,
    )
    makeObservable(this)
  }

  public render() {
    const { customFilter } = this.props
    return (
      <div className="label">
        <div className="name-cell nowrap">
          <FilterLabel customFilter={customFilter} />
        </div>
        <div className="row count-cell">{this.activityCountByCustomFilter}</div>
        <div className="row">
          <ChevronRightIcon
            size={16}
            className="arrow-icon"
            onClick={this.editClicked}
          />
        </div>
      </div>
    )
  }

  @action.bound
  private editClicked() {
    const {
      customFilter: { id },
      selectCustomFilterById,
      editCustomFilter,
    } = this.props
    selectCustomFilterById(id)
    editCustomFilter()
  }
}
